.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.radio {
  display: flex;
  align-items: center;
}

gz-radio {
  width: fit-content;
  margin-right: calc(2 * var(--spacer));

  &#policy-panel-recurrence-schedule-radio {
    width: calc(250px - calc(7 * var(--spacer)));
  }

  &#policy-panel-recurrence-weekdays-radio {
    min-width: 194px;
    margin-bottom: calc(var(--spacer) * 2);
  }
}

#tasks-exclusions-profile-field {
  --margin-bottom-wrapper: 0px;
  gz-radio-group {
    margin-bottom: 0px;
  }
}

gz-policy-panel-antimalware-on-demand-scan-target-table, gz-policy-panel-antimalware-on-demand-exclusions-table {
  margin-top: -8px;
}

#tasks-exclusions-task-list-field {
  margin-left: 24px;
}

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.title-header {
  gz-title {
    width: fit-content;
  }
}
